import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/sistema/pasarelas-pago/monedas-soportadas`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  monedaJSON(idMoneda, params) {
    params = params || {}
    return apiClient.get(`${idMoneda}.json`, { params: params })
  },

  monedasJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/sistema/pasarelas-pago/monedas-soportadas.json`, { params: params })
  }
}